export default "__VITE_ASSET__C8BDa5OL__"